import SessionAccessPage from './SessionAccessPage';

export default SessionAccessPage;
